import { ScrollStrategy } from '@angular/cdk/overlay';

export class BodyOverflowHiddenScrollStrategy implements ScrollStrategy {
    /**
     *
     */
    constructor() {

    }
    enable() {
        // document.body.style.setProperty("overflow", "hidden");
        // document.body.style.setProperty("padding-right", "17px");
        document.body.addEventListener("wheel", this.stopScroll, { passive: false });
        document.body.addEventListener("keydown", this.stopKeyScroll, { passive: false });
    }


    disable() {
        document.body.removeEventListener("wheel", this.stopScroll);
        document.body.removeEventListener("keydown", this.stopKeyScroll);
    }
    attach(overlayRef: any) {
        document.body.addEventListener("wheel", this.stopScroll, { passive: false });
        document.body.addEventListener("keydown", this.stopKeyScroll, { passive: false });
    };
    detach() {
        document.body.removeEventListener("wheel", this.stopScroll);
        document.body.removeEventListener("keydown", this.stopKeyScroll);
    }


    stopScroll(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }

    stopKeyScroll(event: KeyboardEvent) {
        var keyCode = event.key;
        if (keyCode === "ArrowDown" || keyCode === "ArrowUp") {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }

}